import { animate, style, transition, trigger } from '@angular/animations';

export const AlertsAnimations = [
    trigger('alertState', [
        transition(':enter', [
            style({ transform: 'translateY(-100%)', opacity: 0, 'max-height': 0 }),
            animate('200ms ease-in-out', style({ transform: 'translateY(0)', opacity: 1, 'max-height': '100px' }))
        ]),
        transition(':leave', [
            animate('200ms ease-in-out', style({ transform: 'translateX(-120%)', opacity: 0, 'max-height': 0 }))
        ])
    ])
];
